import { StartRating } from "@components/StartRating"
import React, { useState } from "react"
import cn from "classnames"
import css from "../ListingsFilter.module.scss"

type Props = {
    defaultValue?: number
    onChange?: (rating: number) => void
}

export function StarsSelect({ defaultValue = 1, onChange }: Props) {
    const [value, setValue] = useState(defaultValue)
    const handleChange = (v: number) => {
        const newValue = value === v ? 1 : v
        setValue(newValue)
        if (onChange) {
            onChange(newValue)
        }
    }
    return (
        <div role="listbox" className={css.starsSelect}>
            <div role="option" aria-selected={value <= 5 ? "true" : "false"} className={cn(css.ratingWrap, value <= 5 && css.active)} onClick={() => handleChange(5)}>
                <StartRating size={15} gap={5} rating={5} />
            </div>
            <div role="option" aria-selected={value <= 4 ? "true" : "false"} className={cn(css.ratingWrap, value <= 4 && css.active)} onClick={() => handleChange(4)}>
                <StartRating size={15} gap={5} rating={4} /> & Up
            </div>
            <div role="option" aria-selected={value <= 3 ? "true" : "false"} className={cn(css.ratingWrap, value <= 3 && css.active)} onClick={() => handleChange(3)}>
                <StartRating size={15} gap={5} rating={3} /> & Up
            </div>
            <div role="option" aria-selected={value <= 2 ? "true" : "false"} className={cn(css.ratingWrap, value <= 2 && css.active)} onClick={() => handleChange(2)}>
                <StartRating size={15} gap={5} rating={2} /> & Up
            </div>
            <div role="option" aria-selected={value <= 1 ? "true" : "false"} className={cn(css.ratingWrap, value <= 1 && css.active)} onClick={() => handleChange(1)}>
                <StartRating size={15} gap={5} rating={1} /> & Up
            </div>
        </div>
    )
}
